import React from 'react';
import I18n from 'utils/I18n';
import clsx from '@strava/ui/clsx';
import { trackV2 } from 'utils/analytics';

import {
  setMonthlyDuration,
  setYearlyDuration
} from '../../../state/Checkout.actions';
import { useCheckoutContext } from '../../../state/CheckoutContext';
import { getStyles as _getStyles } from '../../../utils/checkoutUtils';
import { I18nPrefixOrganic } from '../../../shared/constants';

import styles from './DurationSelectSideBySide.scss';

export const DurationSelectSideBySide = () => {
  const { checkoutEntityState, dispatch } = useCheckoutContext();

  const {
    analyticsData,
    checkoutSubmitting,
    duration,
    products,
    promoCodeSubmitting,
    yearlyPercentOff,
    experiments
  } = checkoutEntityState;

  const disabled =
    checkoutSubmitting || promoCodeSubmitting || products?.promotion?.full;

  const { shouldShowCheckoutRefresh } = experiments;

  const getStyles = (style) =>
    _getStyles(styles, style, shouldShowCheckoutRefresh);

  const handleDurationChange = ({ durationSelected, dispatchAction }) => {
    trackV2({
      category: 'summit_upsell',
      page: 'cart',
      action: 'change_duration',
      properties: {
        ...analyticsData,
        duration: durationSelected,
        subscription_type: 'organic'
      }
    });

    dispatch(dispatchAction());
  };

  return (
    <div
      className={clsx('btn-group', getStyles('durationSelect'))}
      role="radiogroup"
      data-testid="duration-select-side-by-side"
    >
      <label
        className={clsx('btn', 'btn-default', styles.durationBtn)}
        htmlFor="duration-side-by-side-yearly"
      >
        <input
          id="duration-side-by-side-yearly"
          type="radio"
          name="duration-side-by-side"
          aria-labelledby="duration-side-by-side-yearly"
          checked={duration === 'yearly'}
          aria-checked={duration === 'monthly'}
          disabled={disabled}
          onChange={() =>
            handleDurationChange({
              durationSelected: 'yearly',
              dispatchAction: setYearlyDuration
            })
          }
        />
        <p className={styles.durationText}>
          {I18n.t(`${I18nPrefixOrganic}.yearly`)}
          <span className={styles.yearlyPercentOff}>
            {shouldShowCheckoutRefresh
              ? I18n.t(`${I18nPrefixOrganic}.best_value`)
              : I18n.t(`${I18nPrefixOrganic}.saving`, {
                  percent: Math.round(yearlyPercentOff)
                })}
          </span>
        </p>
      </label>
      <label
        className={clsx('btn', 'btn-default', styles.durationBtn)}
        htmlFor="duration-side-by-side-monthly"
      >
        <input
          id="duration-side-by-side-monthly"
          type="radio"
          name="duration-side-by-side"
          aria-labelledby="duration-side-by-side-monthly"
          checked={duration === 'monthly'}
          aria-checked={duration === 'monthly'}
          disabled={disabled}
          onChange={() =>
            handleDurationChange({
              durationSelected: 'monthly',
              dispatchAction: setMonthlyDuration
            })
          }
        />
        <p className={styles.durationText}>
          {I18n.t(`${I18nPrefixOrganic}.monthly`)}
        </p>
      </label>
    </div>
  );
};

export default DurationSelectSideBySide;
